import FormFieldType from './FormFieldType';

import FormTextField from './FormFieldType/FormTextField';
import FormDate from './FormFieldType/FormDate';
import FormDateTime from './FormFieldType/FormDateTime';
import FormTextArea from './FormFieldType/FormTextArea';
import FormSelect from './FormFieldType/FormSelect';
import FormSelectChip from './FormFieldType/FormSelectChip';
import FormCheckBox from './FormFieldType/FormCheckBox';

const FormFieldFactory = ({ field, handleChangeField }) => {
  const { type } = field;

  switch (type) {
    case FormFieldType.TEXT_FIELD:
      return FormTextField({ field, handleChangeField });
    case FormFieldType.DATE:
      return FormDate({ field, handleChangeField });
    case FormFieldType.DATETIME:
      return FormDateTime({ field, handleChangeField });
    case FormFieldType.SELECT:
      return FormSelect({ field, handleChangeField });
    case FormFieldType.TEXT_AREA:
      return FormTextArea({ field, handleChangeField });
    case FormFieldType.SELECT_CHIP:
      return FormSelectChip({ field, handleChangeField });
    case FormFieldType.CHECKBOX:
      return FormCheckBox({ field, handleChangeField });
    default:
  }
};

export default FormFieldFactory;
